/**
* Images Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Images Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'images-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.images-slider' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--images-slider' )[0], {
          pagination: false,
          arrows: true,
          gap: '32px',
          perPage: 1,
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'images-slider', COMPONENT );
} )( app );
